export const PAGE_NAVIGATION_KEYS = {
  adminOrganizations: "page-nav:admin-organizations",
  agents: "page-nav:agents",
  benchmarkRunsStt: "page-nav:benchmark-runs-stt",
  benchmarkRunsTts: "page-nav:benchmark-runs-tts",
  benchmarkSttDatasets: "page-nav:benchmark-stt-datasets",
  benchmarkTtsDatasets: "page-nav:benchmark-tts-datasets",
  conversations: "page-nav:conversations",
  metrics: "page-nav:metrics",
  alerts: "page-nav:alerts",
  reports: "page-nav:reports",
  runs: "page-nav:runs",
  simulations: "page-nav:simulations",
  scheduledRuns: "page-nav:scheduled-runs",
  templates: "page-nav:templates",
  testSets: "page-nav:test-sets",
} as const
